module.exports = __webpack_public_path__ + "static/img/12.8f71e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/companyLogo/12.png
// module id = kSoR
// module chunks = 1